import { render, staticRenderFns } from "./plan-tile.vue?vue&type=template&id=38a40904&scoped=true"
import script from "./plan-tile.vue?vue&type=script&lang=js"
export * from "./plan-tile.vue?vue&type=script&lang=js"
import style0 from "./plan-tile.vue?vue&type=style&index=0&id=38a40904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a40904",
  null
  
)

export default component.exports